import { Component, Input, OnInit } from '@angular/core';
import { set } from 'date-fns';
export enum statusAlert {
  initial = 'Por definir',
  proceed = 'Procede',
  refusedApproved = 'No procede',
  assigned = 'Por definir',
  finalized = 'Finalizado',
}
@Component({
  selector: 'datos-caso-skuld',
  styleUrls: ['../datos-cliente-skuld/datos-cliente-skuld.component.scss'],
  templateUrl: './datos-caso-skuld.component.html',
})
export class DatosCasoSkuldComponent implements OnInit {
  @Input() case: any;
  @Input() alert: any;
  @Input() status: any;

  statusAlert = statusAlert;

  ngOnInit() {}
  get data() {
    return true;
  }
}
